import { cx } from '@emotion/css';
import { Button } from '@sortlist-frontend/design-system/legacy';
import update from 'immutability-helper';
import { FC, Fragment, ReactNode, useEffect, useRef, useState } from 'react';

import { DragAndDrop } from '_core/dnd/drag-and-drop';

import { DraggableListItem } from './DraggableListItem';

type DraggableListProps = {
  items?: {
    id: number;
    children: ReactNode;
  }[];
  className?: string;
  onChange?: ({ id, position, orderedIds }: { id: number; position: number; orderedIds: number[] }) => void;
  disabled?: boolean;
  placeholder: ReactNode | string;
};

export const DraggableList: FC<DraggableListProps> = (props) => {
  const { items, disabled, onChange, placeholder, className } = props;
  const [cards, setCards] = useState<DraggableListProps['items']>(items);
  const refCards = useRef(cards);

  useEffect(() => {
    setCards(items);
  }, [items]);

  const moveCard = (dragIndex: number, hoverIndex: number) => {
    if (cards) {
      const dragCard = cards[dragIndex];
      setCards(
        update(cards, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragCard],
          ],
        }),
      );
    }
  };

  const onDropEnd = ({ id, index }: { id: number; index: number }) => {
    if (refCards.current) {
      onChange && onChange({ id: id, position: index, orderedIds: refCards.current.map((card) => card.id) });
    }
  };

  useEffect(() => {
    refCards.current = cards;
  }, [cards]);

  return (
    <DragAndDrop>
      <div className={cx(className, 'p-4 bg-secondary-50 rounded-lg border border-secondary-300')}>
        {cards && cards.length > 0 ? (
          <Fragment>
            {cards.map((card, i) => (
              <DraggableListItem
                key={card.id}
                index={i}
                id={card.id}
                moveCard={moveCard}
                onDropEnd={onDropEnd}
                disabled={disabled}
                className={cx(cards.length !== i + 1 && 'mb-2')}>
                {card.children}
              </DraggableListItem>
            ))}
          </Fragment>
        ) : (
          <Fragment>{placeholder}</Fragment>
        )}
      </div>
    </DragAndDrop>
  );
};
